<a class="skip-link" href="#partner-access">Skip to sign in</a>
<header class="portal-header">
  <div class="brand">
    <img width="181" height="32" ngSrc="assets/logo/cybera-logo-dark.svg" alt="CYBERA" priority />
    <span class="brand-divider" aria-hidden="true"></span>
    <span class="portal-label">Partner portal</span>
  </div>
</header>
<main>
  <section class="hero" aria-labelledby="hero-title">
    <div class="hero-copy">
      <p class="eyebrow">THE CYBERA PARTNER NETWORK</p>
      <h1 id="hero-title">Intelligence shared.<br /><span>Fraud disrupted.</span></h1>
      <p class="hero-description">
        Verified intelligence on scam-linked accounts. Help your fraud and AML teams detect mule
        activity and stop payments to scammers.
      </p>
      <ul class="audience" aria-label="Partner organizations">
        <li>Financial institutions</li>
        <li>Digital asset platforms</li>
        <li>Insurers</li>
      </ul>
    </div>
    <section class="access-card" id="partner-access" tabindex="-1" aria-labelledby="access-title">
      <div class="access-main">
        <h2 id="access-title">Welcome back.</h2>
        <p class="access-description">Access your partner dashboard.</p>
        <button pButton type="button" class="sign-in-button" (click)="login.emit()">
          <span pButtonLabel>Sign in</span><i class="pi pi-arrow-up-right" aria-hidden="true"></i>
        </button>
      </div>
      <div class="access-help">
        <p>Need access?</p>
        <span>Contact your administrator or CYBERA account team.</span>
      </div>
    </section>
  </section>
  <section class="scam-response-access" aria-labelledby="scam-response-access-title">
    <div class="scam-response-access-copy">
      <p class="eyebrow">SCAM RESPONSE</p>
      <h2 id="scam-response-access-title">
        Need access to your scam reporting and aftercare dashboard?
      </h2>
    </div>
    <a
      class="scam-response-access-link"
      href="http://report.cybera.io/login"
      target="_blank"
      rel="noopener noreferrer">
      <span>Go to your dashboard</span><i class="pi pi-arrow-up-right" aria-hidden="true"></i>
    </a>
  </section>
  <section class="platform" aria-labelledby="platform-title">
    <div class="platform-heading">
      <div>
        <p class="eyebrow">CYBERA MULE INTELLIGENCE</p>
        <h2 id="platform-title">Know where the risk is.</h2>
      </div>
      <p class="platform-description">
        Account intelligence confirmed through direct investigation. Give your fraud, AML and
        compliance teams the evidence to act with confidence.
      </p>
    </div>
    <div class="use-cases">
      <article class="use-case">
        <p class="use-case-label">PAYMENT FRAUD PREVENTION</p>
        <h3>Screen payment beneficiaries</h3>
        <p>
          Check destination accounts against verified mule intelligence before funds leave your
          institution. Identify payments headed to known scam-linked accounts and intervene early.
        </p>
        <a
          href="https://www.cybera.io/use-case/beneficiary-screening"
          target="_blank"
          rel="noopener noreferrer"
          >Beneficiary screening <i class="pi pi-arrow-up-right" aria-hidden="true"></i
        ></a>
      </article>
      <article class="use-case">
        <p class="use-case-label">AML INVESTIGATIONS</p>
        <h3>Find mules in your customer base</h3>
        <p>
          Identify accounts connected to scam activity within your own institution. Bring verified
          intelligence into investigations, account reviews and suspicious activity reporting.
        </p>
        <a
          href="https://www.cybera.io/use-case/mule-account-screening"
          target="_blank"
          rel="noopener noreferrer"
          >Mule account screening <i class="pi pi-arrow-up-right" aria-hidden="true"></i
        ></a>
      </article>
    </div>
    <div class="integration">
      <div>
        <h3>Connected to your existing systems</h3>
        <p>
          Bring real-time mule intelligence into your fraud and AML workflows through CYBERA’s API.
        </p>
      </div>
      <a
        href="https://www.cybera.io/solutions/cybera-mule-intelligence"
        target="_blank"
        rel="noopener noreferrer"
        >Explore Mule Intelligence <i class="pi pi-arrow-up-right" aria-hidden="true"></i
      ></a>
    </div>
  </section>
</main>
<footer class="portal-footer">
  <span>CYBERA. Together against financial cybercrime.</span>
  <nav class="footer-links" aria-label="Company information">
    <a href="https://www.cybera.io/" target="_blank" rel="noopener noreferrer"
      >Visit cybera.io <i class="pi pi-arrow-up-right" aria-hidden="true"></i
    ></a>
    <a
      href="https://www.cybera.io/reference/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      >Privacy policy</a
    >
  </nav>
  <!-- Temporary reporting transition notice. Remove this block and its reporting-notice styles together. -->
  <details class="reporting-notice">
    <summary>Looking to report a scam?</summary>
    <p>
      CYBERA now accepts victim reports only through selected partners. If a partner has referred
      you, please use the reporting link they provided. Otherwise, contact your financial
      institution to ask about available support.
    </p>
  </details>
</footer>
